module.exports = __webpack_public_path__ + "themes/mf/sound/audio-sprite.mp3";


//////////////////
// WEBPACK FOOTER
// ./themes/mf/sound/audio-sprite.mp3
// module id = 48
// module chunks = 3